"use client";

import CTA from "@/components/Category/CTA";
import ToFAQ from "@/components/Category/ToFAQ";
import { site } from "@/data/default";
import { ReactNode } from "react";

const komputerTangsel: ReactNode = (
  <>
    <h2 className="text-xl font-bold mb-3">Rasanya Sewa Komputer di Tangerang Selatan: Bukan Sekadar Praktis, Tapi Visioner</h2>
    <p className="mb-4">
      Ada yang pernah skeptis dengan jasa <strong>sewa komputer Tangerang Selatan</strong>. Tapi setelah tiga proyek gagal karena laptop timnya ngadat, dia sadar “kalau ingin hasil kerja optimal, ya jangan kompromi pada perangkat.” Dia beralih ke sewa, dan sejak itu, semua berubah saat negara api menyerang.
    </p>

    <h3 className="text-lg font-semibold mb-2">Wajib Sewa Komputer Tangerang Selatan, Bukan Beli, kenapa?</h3>
    <ul className="list-disc list-inside mb-6 space-y-2 text-sm">
      <li>📈 Skala proyek naik-turun, jadi lebih fleksibel pakai sistem sewa</li>
      <li>💰 Biaya awal 0, bisa langsung jalanin proyek tanpa keluar modal besar</li>
      <li>⚙️ Bebas pilih spek dan brand sesuai kebutuhan: dari Dell, Lenovo, HP sampai rakitan custom</li>
      <li>🧑‍🔧 Dukungan teknisi lokal Tangsel 24 jam nonstop. Nggak cuma jaga, tapi proaktif bantu</li>
    </ul>

    <h2 className="text-xl font-bold mb-3">Area Jangkauan Sewa Komputer Tangerang Selatan</h2>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
      <div className="bg-white p-4 rounded-xl border border-gray-200 shadow-md">
        <h4 className="font-semibold mb-1">🌆 BSD City</h4>
        <p className="text-sm">Wilayah kampus & startup? Kami rutin kirim unit ke coworking dan inkubator di BSD.</p>
      </div>
      <div className="bg-white p-4 rounded-xl border border-gray-200 shadow-md">
        <h4 className="font-semibold mb-1">🌳 Bintaro</h4>
        <p className="text-sm">Perumahan dan cluster elit, aman untuk pengantaran komputer high-end.</p>
      </div>
      <div className="bg-white p-4 rounded-xl border border-gray-200 shadow-md">
        <h4 className="font-semibold mb-1">🎓 Ciputat & Pamulang</h4>
        <p className="text-sm">Event seminar kampus, workshop pelajar, atau proyek dosen? Sewa kami support semuanya.</p>
      </div>
      <div className="bg-white p-4 rounded-xl border border-gray-200 shadow-md">
        <h4 className="font-semibold mb-1">🏘️ Serpong & Setu</h4>
        <p className="text-sm">Area perumahan berkembang, cocok untuk remote worker dan creative team.</p>
      </div>
    </div>

    <h2 className="text-xl font-bold mb-3">Varian Tipe & Spek Komputer Sewa di Tangsel</h2>
    <p className="mb-4">
      Dari pengalaman, klien kami rata² butuh komputer dengan spek yang bukan sekadar “jalan”, tapi harus tahan kerja berat.
    </p>
    <ul className="list-decimal list-inside mb-6 space-y-1 text-sm">
      <li><strong>Basic Office</strong>: Core i3/i5, RAM 8GB, SSD 256GB</li>
      <li><strong>Desain & Multimedia</strong>: Ryzen 5/i7, RAM 16GB, GPU GTX/RTX, SSD 512GB</li>
      <li><strong>Server Mini / Data Analyst</strong>: Xeon/ECC, RAM 32GB+, dual drive setup</li>
    </ul>
    <p className="mb-4">
      Semua unit <strong>sewa komputer Tangerang Selatan</strong> disiapkan fresh, update software & antivirus, dan diuji performanya sebelum dikirim.
    </p>

    <h3 className="text-lg font-semibold mb-2">Harga Sewa Komputer Tangerang Selatan: Transparan & Fleksibel</h3>
    <p className="mb-4">
      Kami percaya harga itu harus fair. Makanya, <strong>harga sewa komputer Tangerang Selatan</strong> selalu menyesuaikan:
    </p>
    <ul className="list-disc list-inside mb-6 text-sm space-y-1">
      <li>Durasi: harian, mingguan, atau bulanan</li>
      <li>Tipe unit: dari komputer biasa sampai workstation</li>
      <li>Jumlah unit: 1 unit atau 100 unit, tetap bisa kami support</li>
    </ul>

    <h2 className="text-xl font-bold mb-3">Kapan Harus Sewa Komputer di Tangerang Selatan?</h2>
    <p className="mb-4">
      Berdasarkan pengalaman, permintaan tertinggi biasanya datang dari:
    </p>
    <ul className="list-disc list-inside mb-6 text-sm space-y-1">
      <li>🚀 Event komunitas, hackathon, seminar</li>
      <li>🏢 Kebutuhan kantor cabang baru atau proyek temporer</li>
      <li>🎮 Kelas desain grafis, rendering, hingga simulasi</li>
      <li>🧑‍💼 Freelancer yang ingin tampil profesional di hadapan klien</li>
    </ul>

    <h2 className="text-xl font-bold mb-3">Layanan Tambahan Sewa Komputer Tangsel</h2>
    <p className="mb-2">
      Kami bukan sekadar drop & go. Layanan <strong>sewa komputer Tangerang Selatan</strong> kami dilengkapi:
    </p>
    <ul className="list-disc list-inside mb-6 text-sm space-y-1">
      <li>✅ Instalasi software sesuai kebutuhan</li>
      <li>✅ Setup jaringan (LAN/Wi-Fi)</li>
      <li>✅ Support maintenance on-site & remote</li>
      <li>✅ Penjemputan unit pas selesai sewa</li>
    </ul>

    <h2 className="text-xl font-bold mb-3">Apa Kata Klien Kami di Tangerang Selatan?</h2>
    <p className="italic mb-4">“Awalnya ragu sewa komputer buat kelas desain. Tapi semua berjalan lancar, teknisi standby terus, komputer high-end, dan murid² puas. Repeat order pasti.”, Rika, Dosen Desain Interior</p>

    <p className="italic mb-4">“Butuh 30 unit untuk pelatihan instansi. Dikirim H-1, dicek satu², dan diambil tepat waktu. Layanan sewa komputer di Tangsel terbaik yang pernah kami pakai.”, Haris, EO Pemerintah</p>

    <CTA
      title="Butuh Komputer Siap Tempur di Tangsel?"
      description="🚛 Booking <strong>sewa komputer Tangerang Selatan</strong> hari ini. Kapan pun kamu butuh, kami antar unitnya langsung ke lokasi. Tanpa ribet, tanpa drama."
      buttonText="Booking Sekarang"
      onClick={() => {
        window.open(
          `https://wa.me/${site.whatsapp}?text=Halo%2C%20saya%20ingin%20booking%20komputer%20untuk%20Tangerang%20Selatan.%20Mohon info ketersediaan dan harganya.`,
          "_blank"
        );
      }}
    />

    <ToFAQ category="Komputer" />
  </>
);

export default komputerTangsel;